import { FC } from "react";
import { LucideIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";
import { OnboardingTextType } from "@/utils/onboarding";
import { cn } from "@/utils/tailwind";

type PhotoCardRowPropsType = {
  icon: LucideIcon;
  text: OnboardingTextType;
  onPress?: () => void;
  isSelected?: boolean;
};

// A darker row on the maroon card.
export const PhotoCardRow: FC<PhotoCardRowPropsType> = ({
  icon,
  text,
  onPress,
  isSelected = false,
}) => {
  const className = cn(
    "flex-row items-center gap-4 rounded-md border bg-black/15 p-4",
    {
      "border-primary": isSelected,
      "border-transparent": !isSelected,
    },
  );

  const content = (
    <>
      <VnIcon as={icon} size={24} className="text-primary" />
      <VnText variant="lgBold" className="flex-1 text-white" {...text} />
    </>
  );

  if (!onPress) {
    return <VnBox className={className}>{content}</VnBox>;
  }

  return (
    <VnTouchableOpacity
      className={className}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityState={{ selected: isSelected }}>
      {content}
    </VnTouchableOpacity>
  );
};
